<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item label="外销合同编号：">
        <el-input size="mini" v-model="dataForm.fuzzyOrderCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="收货工厂：" v-if="queryType==='order'">
        <el-input size="mini" v-model="dataForm.receiverName" clearable></el-input>
      </el-form-item>
      <el-form-item label="发货工厂：" v-if="queryType==='wait_receive'">
        <el-input size="mini" v-model="dataForm.sellerName" clearable></el-input>
      </el-form-item>
      <el-form-item prop="productName" label="品名：">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            placeholder="品名"
            style="width: 240px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="请输入颜色"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="请输入规格"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="请输入幅宽"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="请输入克重"
            style="width: 200px;"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini" type="primary">{{ $t('query') }}</el-button>
        <el-button @click="doSend()" size="mini" type="warning" v-if="queryType==='order'">发货</el-button>
        <el-button @click="showReceiveDialog()" size="mini" type="warning" v-if="queryType==='wait_receive'">确认收货
        </el-button>
      </el-form-item>
    </el-form>
    <SweetTable ref="table" :selection="true" api-version="v2" url="/erp/purchase/page" :auto-load="false"
                :query-form="dataForm" :before-table-binding="beforeTableBinding">
      <el-table-column
          prop="orderCode"
          label="外销合同编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          v-if="queryType==='wait_receive'"
          prop="companyName"
          label="发货工厂"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          v-if="queryType==='order'"
          prop="receiverName"
          label="收货工厂"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="品名"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="price"
          label="单价"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="planCount"
          label="计划数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          label="待收货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="120"
          v-if="queryType==='wait_receive'"
      >
      </el-table-column>
      <el-table-column
          label="待收货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="120"
          v-if="queryType==='order'"
      >
      </el-table-column>
      <el-table-column
          prop="receiveCount"
          label="已收货"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>
      <el-table-column
          prop="totalSendCount"
          label="总发货数"
          header-align="center"
          align="center"
          width="120"
      >
      </el-table-column>

    </SweetTable>
    <SendDialog ref="SendDialog" @change="getDataList"></SendDialog>
    <ReceiveDialog ref="ReceiveDialog" @change="getDataList"></ReceiveDialog>

  </div>
</template>

<script>
import SendDialog from '@/views/modules/erp/client/common/PurchaseSendDialog.vue'
import ReceiveDialog from '@/views/modules/erp/client/common/receive-dialog.vue'
import SweetTable from '@/mixins/SweetTable'
import BigNumber from 'bignumber.js'

export default {
  mixins: [SweetTable],
  components: { SendDialog, ReceiveDialog },
  props: {
    queryType: {
      type: String,
      default: 'order'
    }
  },
  data () {
    return {
      dateArr: [],
      dataForm: {
        fuzzyOrderCode:'',
        queryType: 'order',
        orderCode: '',
        sellerName: '',
        receiverName: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
      },
    }
  },
  watch: {
    queryType: {
      handler: function (newVal) {
        this.dataForm.queryType = newVal
        this.reload()
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    showReceiveDialog () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择收货内容')
      }
      for (let i = 0; i < rows.length; i++) {
        let sendCount = new BigNumber(rows[i].sendCount)
        if (sendCount.lte(0)) {
          return this.$message.error(`第${i + 1}行待收货数量为0，请重新选择`)
        }
      }
      let queryParams = rows.map(item => {
        return {
          sourceId: item.id,
          sourceType: 'purchase'
        }
      })
      //根据原始订单信息读取要收货的明细
      this.$api2.post(`/trade/factorystorelog/query/list/for-receive`, queryParams).then(res => {
        res.forEach(item => {
          item.receiveCount = item.sendCount
        })
        this.$refs.ReceiveDialog.init(res)
      })
    },
    doSend () {
      let rows = this.$refs.table.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要发货的订单')
      }
      let receiverId = rows[0].receiverId
      if (rows.find(r => r.receiverId !== receiverId)) {
        return this.$message.error('收货方不一致，请选择同一收货方的订单')
      }

      rows = rows.map(item => {
        let currentSendCount = new BigNumber(item.planCount).minus(item.totalSendCount)
        if (currentSendCount.lte(0)) {
          currentSendCount = 0
        } else {
          currentSendCount = currentSendCount.toFixed(3)
        }
        return {
          orderCode: item.orderCode,
          sourceId: item.id,
          sourceType: 'purchase',
          productId: item.productId,
          product: item.product,
          totalSendCount: item.totalSendCount,
          planCount: item.planCount,
          sendCount: currentSendCount,
          price: item.price,
          receiverId: item.receiverId,
          receiverName: item.receiverName,
          remark: '',
          totalAmount: new BigNumber(currentSendCount).multipliedBy(item.price).toFixed(3)
        }
      })
      this.$refs.SendDialog.receiverList = [{ id: receiverId, name: rows[0].receiverName }]
      this.$refs.SendDialog.sendType = 'purchase'
      this.$refs.SendDialog.init(rows)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.price = row.amount
        row.planCount = row.count
        row.totalSendCount = new BigNumber(row.sendCount).plus(row.receiveCount).toFixed(3)
      })
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
